var baseurl = (typeof baseurl !== 'undefined') ? baseurl : '/';



// var scripts = (scripts === undefined) ? [] : scripts;



(function ($) 
{
	$.fn.getOption = function(option,params) 
	{
		switch(option) 
		{
			case 'setAvatar':
				$('input#' + option).click();

				break;

			case 'setAvatarUploaded':
				$('img.avatar').attr('src',baseurl + params.path + '?' + Math.floor(Math.random() * Math.floor(1000000)));

				break;

			case 'stop':
				document.location.href = baseurl + 'profile/games';

				break;

			case 'rules':
				document.location.href = baseurl + 'profile/rules';

				break;

			default:
				$(window).message('Javascript событие ' + option + ' не найдено Х-(\nОбратитесь к разработчику',2);
				// alert('Javascript событие ' + option + ' не найдено Х-(\nОбратитесь к разработчику');
				break;
		}

		return;
	};

	$.fn.done = function(html, btn_html) 
	{
		btn_html = !btn_html ? '' : btn_html;
		console.log(btn_html);
		$('#done .buttons', this).find('a.btn-green').remove();
		$(btn_html).insertBefore($('#done .buttons a:first', this));
		// $('#done .buttons', this).append(btn_html);
		$('#done .result', this).html(html);

		$(this).addClass('done');

		return;
	};

	$.fn.message = function(text,type) 
	{
		if(!$('body').find('.message').length)
			$('body').append('<div class="message alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span class="small" aria-hidden="true">&times;</span></button><span></span></div>');

		$('body')
		.find('.message')
		.addClass('show')
		.find('> span')
		.html(text);

		console.log(type);

		switch(type) 
		{
			case 'success':
			case '1':
			case 1:
				var altClass = 'alert-success';

				break;

			case 'error':
			case 2:
			case '2':
			case 'danger':
				var altClass = 'alert-danger';

				break;

			default:
				var altClass = 'alert-warning';
				break;
		}

		$('body')
		.find('.message')
		.addClass(altClass);

		return;
	};
})(jQuery);

$.getScript(baseurl + 'assets/chosen.jquery.min.js', function()
{
	$('select').chosen();
});

$(function()
{
	$('select[name="level"]').change(function()
	{
		$(this).parent().submit();
	});

	$('.change-form').change(function()
	{
		$('.change-form').submit();
	});

	$('[name="login"],[name="passw"]').change(function()
	{
		var val = $.trim($(this).val());
		$(this).val(val);
	});

	$('.tabs-nav').on('click','a.btn', function(e)
	{
		e.preventDefault();

		$('.tabs-container > *').addClass('d-none');
		$('.tabs-container > ' + $(this).attr('href')).removeClass('d-none');
		$('.tabs-nav').find('a.btn').addClass('btn-white');
		$(this).removeClass('btn-white');
	});

	$('body').on('submit','form',function(e)
	{
		var error = 0;
		var text = '';
		var method = $(this).attr('method');	
		var action = $(this).attr('action');

		var form = $(this);

		$('.required,.r',this).each(function()
		{
			//проверка поля телефона
			if($(this).attr('name').indexOf('phone') >= 0)
			{
				var val = $(this).val();

				val = val.replace(/[^0-9]/gim,'');

				if(val.length != 11)
				{
					error++;
					$(this).addClass('has-error');
					text+= '- <b>Номер телефона введен некорректно</b><br />';
				}
				else 
					$(this).removeClass('has-error');
				
			} 
			else if($(this).attr('name').indexOf('mail') >= 0)
			{	//проверка поля email
				var val = $(this).val();

				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

				if(!re.test(String(val).toLowerCase()))
				{
					error++;
					$(this).addClass('has-error');
					text+= '- <b>Email введен некорректно</b><br />';
				}
				else
					$(this).removeClass('has-error');
			} else if($(this).val().length < 1)
			{	// проверка отстальных полей
				var name = $(this).attr('name');
				var id = $(this).attr('id');

				if(form.find('label[for="' + name + '"]').length)
					text+= '- <b>' + form.find('label[for="' + name + '"]').text() + '</b><br />';
				else if(form.find('label[for="' + id + '"]').length)
					text+= '- <b>' + form.find('label[for="' + id + '"]').text() + '</b><br />';
				else if($(this).attr('placeholder') !== undefined)
					text+= '- <b>' + $(this).attr('placeholder') + '</b><br />';

				var tagname = $(this).prop("tagName");
				// $(this).parent().addClass('has-error');
				$(this).addClass('has-error');
				if(tagname == 'SELECT')
				{
					var select_id = $(this).attr('id') + '_chosen';
					$('#' + select_id + '.chosen-container').addClass('invalid');
				}
				error++;
			} 
			else 
			{
				var tagname = $(this).prop("tagName");
				// $(this).parent().removeClass('has-error');
				$(this).removeClass('has-error');
				if(tagname == 'SELECT')
				{
					var select_id = $(this).attr('id') + '_chosen';
					$('#' + select_id + '.chosen-container').removeClass('invalid');
				}
			}
		});

		$('input[type="checkbox"]',this).each(function()
		{
			if($(this).attr('id').indexOf('agree') >= 0 && !$(this).is(":checked"))
			{
				text+= '- <b>Надо принять условия обработки персональных данных!</b><br />';
				error++;
				$(this).addClass('has-error');
			}
		});

		if(error > 0)
		{			
			if(text.length)
			{
				text = 'Введенные вами данные не будут отправлены, так как не все обязательные поля были заполнены:<br />' + text;
				$(window).message(text, 2);
			}

			e.preventDefault();
		}
		else
		{
			if(method != 'post')
				return;

			var form = $(this);
			var debug = !form.attr('data-debug') ? false : true;
			var otherActions = ['registration','auth','saveProfile','register'];

			action = form.find('button[type="submit"]').length ? form.find('button[type="submit"]').val() : null;

			if(otherActions.indexOf(action) >= 0)
				action = null;

			// if ( $('body').hasClass('profile_page') ) action = null;

			if(action)
			{
				e.preventDefault();

				$.ajax(
				{
					type:'POST',
					method:'POST',
					cashe: false,
					url: baseurl,
					data:{ajax:true,option:action,query:$( this ).serialize()}
				})
				.done(function(msg)
				{
					console.log(msg);
				});
			}
		}
	});
	$('.uploadFile').change(function()
	{
		var form_data = new FormData();

		var t = $(this);

		if($(this).prop('files').length < 1)
			return;

		var uploaded = 0;
		var count_files = $(this).prop('files').length;

		$('body').addClass('loading');

		for (var i = 0; i < $(this).prop('files').length; i++) 
		{
			form_data.append('Filedata', $(this).prop('files')[i]);
			form_data.append('user', user);
			form_data.append('timestamp', timestamp);
			form_data.append('token', token);
		
			if(t.attr('data-size'))
				form_data.append('size', t.attr('data-size'));
			
			if(t.attr('data-folder'))
				form_data.append('folder', t.attr('data-folder'));

			if(t.attr('data-filename'))
				form_data.append('filename', t.attr('data-filename'));

			// var l = getRandomInt(1,1000000);

			$.ajax(
			{
				url: baseurl + 'upload', // point to server-side PHP script 
				dataType: 'text',  // what to expect back from the PHP script, if anything
				cache: false,
				contentType: false,
				processData: false,
				data: form_data,                         
				type: 'post',
				method: 'post',

				success: function(php_script_response)
				{
					var result = $.parseJSON( php_script_response );

					if(t.attr('data-callback'))
						t.getOption(t.attr('data-callback'),result);

					$('body').removeClass('loading');

				    console.log(result); // display response from the PHP script, if any
				}
			});
		}

		console.log(form_data);
	});

	// if(!$('body').find('.message').length)
	// 	$('body').append('<div class="message alert"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span class="small" aria-hidden="true">&times;</span></button><span></span></div>');
	
	if($('.alert').length)
	{
		var text = $('.alert').eq(0).text();

		var type = 1;

		if($('.alert').hasClass('alert-danger'))
			type = 2;

		$('.alert').remove();

		$(window).message(text,type);
	}

	$('body').on('click','.message .close', function(e)
	{
		e.preventDefault();

		$('.message').removeClass('show');
	});

	$('body.profile [name="game_name"]').change(function(e)
	{
		var game_name = $(this).val();
		var parent = $(this).parent().parent().parent();

		$.ajax(
		{
			method: "POST",
			type: "POST",
			cache: false,
			url: baseurl + 'profile',
			data: { option: 'getRecordTable', game_name: game_name, ajax: true }
		})
		.done(function( result ) 
		{
			parent.find('.table').html(result);
			// console.log(result);
		});
	});

	if($('.sidebar').length)
	{
		$.ajax(
		{
			method: "POST",
			type: "POST",
			cache: false,
			url: baseurl,
			data: { option: 'sidebar', user: true, ajax: true }
		})
		.done(function( sidebar_html ) 
		{
			$('.sidebar').html(sidebar_html);

			var current_link = window.location.href;

			var parse = current_link.split('/');

			$('.sidebar').find('a').removeClass('bg-info').removeClass('text-white');

			$('.sidebar').find('a').each(function()
			{
				var part = (parse.length > 5) ? parse[5] : parse[4];
				var href = $(this).attr('href');

				console.log(href + ' - ' + part);

				// if($(this).attr('href') == parse[(parse.length - 1)])
				if(href.indexOf(part) >= 0)
				{
					$(this).addClass('bg-info').addClass('text-white');
					return false;
				}
			});

			$.getScript(baseurl + 'assets/simplebar.min.js');
		});
	}
	
	// $('.sidebar').load(baseurl + 'sidebar.htm', function()
	// {
	// 	var current_link = window.location.href;

	// 	var parse = current_link.split('/');

	// 	$('.sidebar').find('a').removeClass('bg-info').removeClass('text-white');

	// 	$('.sidebar').find('a').each(function()
	// 	{
	// 		if($(this).attr('href') == parse[(parse.length - 1)])
	// 		{
	// 			$(this).addClass('bg-info').addClass('text-white');
	// 			return false;
	// 		}
	// 	});

	// 	$.getScript(baseurl + 'assets/simplebar.min.js');
	// });

	$('body').on('click','.call', function(e)
	{
		e.preventDefault();

		var name = $(this).attr('data-option');
		var options = [];

		$.each(this.attributes, function()
		{
			var n = this.name;
			var v = this.value;

			if(n.indexOf('data-') >= 0)
				options[options.length] = {'name':n.replace('data-',''),'value':v};
			
		});

		$(this).getOption(name,options);
	});
});

$(window).on("load", function (e) 
{
	if(typeof scripts !== 'undefined')
	{
		for (var i = 0; i < scripts.length; i++)
			$.getScript(baseurl + 'assets/' + scripts[i]);
	}
});


// WEBPACK FOOTER //
// ../assets/sources/script.js